import { memoize } from 'lodash-es'
import { EventRecording } from '@/types/event'

const HEVC_MIME_TYPE = 'video/mp4; codecs="hvc1"'

export const formatEventOffset = (ms: number) => {
  const totalSeconds = Math.floor(Math.max(ms, 0) / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60

  return `${minutes}:${String(seconds).padStart(2, '0')}`
}

export const isHevcRecording = (
  recording: Pick<EventRecording, 'video_codec'>
) => recording.video_codec === 'h265'

export const isRecordingUnavailable = (
  recording: Pick<EventRecording, 'recording_mode' | 'video_path'>
) => recording.recording_mode === 'smart_record' && !recording.video_path

export const canPlayHevc = memoize(
  () => document.createElement('video').canPlayType(HEVC_MIME_TYPE) !== ''
)
